import { AnyAction, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "./authReducer";
import { IFieldError } from "../helpers";

export interface IAction extends AnyAction {
    type: string;

    //login action props
    user?: IUser;
    Errs?: IFieldError[];
    field?: string;

    //logout action props
    Err?: string;

    //NavBar action props
    navId?: number;
    userRole?: string;
}

export interface PopUpAction extends IAction {
    popUpId?: number;
}

export interface IPopUp {
    id: number;
    name: string;
    deployed: boolean;
}

export class PopUpsState {
    popUps: IPopUp[] = [];
}

const initState: PopUpsState = {
    popUps: [
        {
            id: 1,
            name: 'Add a new Staff',
            deployed: false
        },
        {
            id: 2,
            name: 'Add new fabric',
            deployed: false
        },
        {
            id: 3,
            name: 'Update fabric',
            deployed: false
        },
        {
            id: 4,
            name: 'Permission prompt',
            deployed: false
        },
        {
            id: 5,
            name: 'Cart',
            deployed: false
        },
        {
            id: 6,
            name: 'Add fabric to Shopping Bag',
            deployed: false
        },
        {
            id: 7,
            name: 'Add clothing-type',
            deployed: false
        },
        {
            id: 8,
            name: 'Add clothing-piece design',
            deployed: false
        },
        {
            id: 9,
            name: 'Tailor Fabric',
            deployed: false
        },
        {
            id: 10,
            name: 'Add Measurement Specification',
            deployed: false
        },
    ]
} as PopUpsState;

const popUpsSlice = createSlice({
    name: 'popUps',
    initialState: initState,
    reducers: {
        deployPopUp: (state: PopUpsState, action: PayloadAction<number>) => {
            const popUpId = action.payload;

            if (popUpId) {
                state.popUps[popUpId - 1].deployed = true;
            }
        },
        closePopUp: (state: PopUpsState, action: PayloadAction<number>) => {
            const popUpId = action.payload;

            if (popUpId) {
                state.popUps[popUpId - 1].deployed = false;
            }
        }
    }

});

export const { deployPopUp, closePopUp } = popUpsSlice.actions;
export default popUpsSlice.reducer;